module.exports = "https://static.wanderu.com/static/media/stars.54cc0037.svg";